<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-入库管理-修改
    -->
    <el-dialog
    title="入库详情"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="80%" 
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">基本信息</div>
      <el-form-item label="入库类型：" >
          {{ form.type_text }}
        </el-form-item>


        <!-- <el-form-item label="供应商：" >
          {{ form.supply.name }}
        </el-form-item>    -->

        <div class="common-form">入库清单</div>   

        <el-table size="small" :data="form.product"   border style="width: 100%" v-loading="loading">
          <el-table-column prop="product_name" label="商品"></el-table-column>
          <el-table-column prop="spec_value" label="规格"></el-table-column>
          <el-table-column prop="unit" label="计量单位"></el-table-column>
          <el-table-column prop="set_num" label="数量">
            <template slot-scope="scope">
              {{ scope.row.set_num }}

            </template>

          </el-table-column>
          <el-table-column prop="product_price" label="单价">
            <template slot-scope="scope">
            
           {{ scope.row.product_price }}
            </template>

          </el-table-column>
          <el-table-column prop="amount" label="金额">
            <template slot-scope="scope">
              {{ scope.row.amount }}
            </template>

          </el-table-column>
          <el-table-column prop="recentInboundPrice" label="最近入库单价"></el-table-column>
          <el-table-column prop="warehousekwtext" label="库区"></el-table-column>
          <el-table-column prop="status" label="入库状态">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0">未入库</div>
              <div v-if="scope.row.status == 1">已入库</div>
            </template>


          </el-table-column>
  

          <!-- 自定义插入一行 -->
          <template v-slot:append  v-if="form.product">
            <div style="float: right;">
              <tr class="custom-footer" style="border: 1px solid red;height: 50px;">
              <!-- 合并列 --> 
             
                <td style=" width: 100px;float: right;line-height: 50px; height: 50px; text-align: center; background-color: #f5f5f5;">
                  {{ form.actualAmount }}
                </td>
                <td style="width: 100px;float: right;line-height: 50px; text-align: center; background-color: #f5f5f5;">
                  实付款
                </td>
                <td style="width: 100px;float: right;line-height: 50px; text-align: center; background-color: #f5f5f5;">
                  {{ form.totalAmount }}
                </td>
                <td  style="width: 100px;float: right;line-height: 50px; text-align: center; font-weight: bold; background-color: #f5f5f5;">
                  总计
                </td>
              <div style="clear: both;"></div>
            </tr>
            </div>
          </template>
        </el-table>


        <div class="common-form">其它费用</div>   

       

            <el-table size="small" :data="form.zf"   border style="width: 100%" v-loading="loading">
          <el-table-column prop="name" label="条目"></el-table-column>

          <el-table-column prop="amount" label="金额">
            <template slot-scope="scope">
              {{ scope.row.price }}
            </template>

          </el-table-column>
          <el-table-column prop="note" label="备注">
            <template slot-scope="scope">
              {{ scope.row.note }}
            </template>

          </el-table-column>



          <!-- 自定义插入一行 -->
          <template v-slot:append>
            <div style="float: right;">
              <tr class="custom-footer" style="border: 1px solid red;">
              <!-- 合并列 --> 
            
                <td style="width: 100px;float: right;line-height: 50px; text-align: center; background-color: #f5f5f5;">
                  {{ form.zfTotalAmount }}
                </td>
                <td  style="width: 100px;float: right;line-height: 50px; text-align: center; font-weight: bold; background-color: #f5f5f5;">
                  总计
                </td>
                <div style="clear: both;"></div>
            
            </tr>
            </div>
          
          </template>
        </el-table>
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import Warehouse_managementApi from '@/api/warehouse_management.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import {mergeTable} from '@/utils/table.js'
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        type:0,
        product:[],
        totalAmount:0,
        actualAmount:0,
        zfTotalAmount:0,
        zf:[],
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入入库管理名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album",
         selectType:'1',
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","warehouse_management_id"],
  methods: {
    // 更新金额（当修改单价时）
    updateAmount(row) {
      row.amount = (row.product_price * row.set_num).toFixed(2);
      this.updateTotalAmount();  // 更新总金额
    },
    // 更新单价（当修改总价时）
    updateUnitPrice(row) {
      if (row.set_num !== 0) {
        row.product_price =  row.amount / row.set_num;
      }
      this.updateTotalAmount();  // 更新总金额
    },
    // 更新总金额
    updateTotalAmount() {
      this.form.totalAmount = this.form.product.reduce((acc, row) => parseFloat(acc) + parseFloat(row.amount), 0);
      this.$forceUpdate()
    },
    updatezfPrice(row) {

      this.form.zfTotalAmount = this.form.zf.reduce((acc, row) => parseFloat(acc) + parseFloat(row.price), 0);
      this.$forceUpdate()
    },
    del(index){
      this.form.product.splice(index,1)
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      Warehouse_managementApi.detail({warehouse_management_id: self.warehouse_management_id},true).then(res => {
          self.form = res.data;
          var product = self.form.product
          for(var i=0;i<product.length;i++){
              self.updateAmount(product[i]);
          }
          self.loading = false;
          
      
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Warehouse_managementApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}



</style>



// WEBPACK FOOTER //
// src/views/plus/warehouse_management/index/part/detail.vue